<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on }">
      <!-- <v-btn class="success" v-on="on"> -->
      <v-icon left v-on="on" small title="Edit" color="primary">edit</v-icon>
      <!-- </v-btn> -->
    </template>
    <v-card>
      <v-card-title>
        <v-icon left>edit_square</v-icon>
        <span class="headline">Edit Agent</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon large color="error">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container grid-list-md class="py-0">
        <v-card-text class="py-0">
          <v-form ref="edit_agent_form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="newAgent.name"
              label="Name *"
              :rules="[(v) => !!v || 'Name is required']"
            ></v-text-field>
            <v-text-field
              type="number"
              v-model="newAgent.numbers_of_agent"
              label="Number of Members *"
              :rules="[
                (v) => !!v || 'Number of Agents is required',
                (v) =>
                  (v && v <= maximumNumberOfAgentMembers) ||
                  `Number of Agents should be less than or equal to ${maximumNumberOfAgentMembers}`,
              ]"
            ></v-text-field>
            <v-text-field
              v-model="newAgent.code"
              label="Code *"
              :rules="[
                (v) => !!v || 'Code is required',
                (v) => /\b.{6}\b/g.test(v) || 'Code must be 6 characters',
              ]"
              disabled
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            :loading="loading"
            :disabled="loading || !valid"
            @click="save"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  export default {
    props: ["agentDetails", "maximumNumberOfAgentMembers"],
    data() {
      return {
        dialog: false,
        loading: false,
        valid: false,
        newAgent: null,
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    created() {
      this.initialize();
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      initialize() {
        this.newAgent = { ...this.agentDetails };
      },
      close() {
        this.dialog = false;
      },
      async save() {
        await this.$refs.edit_agent_form.validate();
        if (this.valid) {
          try {
            this.loading = true;
            const { data } = await api.storeData(
              this.auth.token,
              "agent-group",
              this.newAgent
            );

            if (data.error) {
              this.$emit("result", [data.errorMsg, "error"]);
            } else {
              this.$emit("result", [
                "Agent data updated successfully",
                "success",
              ]);
              this.close();
            }

            // this.loading = false;
          } catch (error) {
            //
          }
          this.loading = false;
        }
      },
    },
  };
</script>
